export {
  illustrationDesktop,
  illustrationLaptop,
  illustrationMobile,
  illustrationTablet
} from './images'
